import { Injectable } from '@angular/core';
import { AppConfigService } from './config-initialization.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private readonly appConfigService: AppConfigService) {}

  async initialize(): Promise<void> {
    await this.loadRuntimeConfig();
    this.appConfigService.setApiUrl();
  }

  private async loadRuntimeConfig(): Promise<void> {
    if (this.isLocalhost()) {
      return;
    }

    try {
      const response = await fetch('./version', {
        cache: 'no-store',
      });

      const cfg = response.headers.get('cfg');
      if (cfg) {
        this.appConfigService.saveApiUrlLocally(cfg);
      }
    } catch {
      // Bootstrap must continue even if the runtime version endpoint is temporarily unavailable.
    }
  }

  public isLocalhost(): boolean {
    return window.location.hostname.includes('localhost');
  }
}
